import React, {useEffect, useState} from 'react';
import Prismic from '@prismicio/client'

import { RichText } from 'prismic-reactjs'
import './Honors.css';
import {orderBy} from 'lodash';

const Honors = ({client}) => {
    
    const [doc, setDoc] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            const response = await client.query(
                Prismic.Predicates.at('document.type', 'honors_awards_grants'), {pageSize: 100}
            )
            if (response) {
                setDoc(response.results);
            }
            }
            fetchData()
        
    }, [client]);

    const render = () => {
        if(doc === null){
            return null;
        } else {
            const sorted = orderBy(doc, function(o){return [o.data.year, o.data.last_publication_date]}, ['desc', 'desc']);
            return(
                <div>
                    {sorted.map(d => <div className="honor" key={d.id}>
                        <div className="date">{d.data.year}{d.data.year_end ? ' - '+d.data.year_end : ''}</div>
                        <div className="title">{d.data.title}</div>
                        {d.data.details && <div className="details"><RichText render={d.data.details} /></div>}
                    </div>)}
                </div>
            )
        }
    };

    return (
        <div className="Main">
            <div className="Honors">
                <h2>Honors and Awards</h2>
                <div className={"honors"}>
                {render()}
                </div>
            </div>
        </div>
    )

}

export default Honors;